import type { TimeSeriesResponse } from 'api';
import { UseChartDataParams, UseChartDataReturn } from '../types';
import { useCompanyMetricChart } from './useCompanyMetricChart';

const MOCK_UNREALIZED_VALUE_DATA: TimeSeriesResponse = {
  company_id: 9999,
  current: {
    date: '2024-12-31',
    value: '2400000',
  },
  change_percent: '14.29',
  history: [
    { date: '2023-12-31', value: '1500000' },
    { date: '2024-03-31', value: '1800000' },
    { date: '2024-06-30', value: '1725000' },
    { date: '2024-09-30', value: '2100000' },
    { date: '2024-12-31', value: '2400000' },
  ],
};

export const useUnrealizedValue = (params: UseChartDataParams): UseChartDataReturn =>
  useCompanyMetricChart({
    ...params,
    metricName: 'unrealized-value',
    label: 'Unrealized Value',
    color: '#3498db',
    emphasisColor: '#2980b9',
    mockData: MOCK_UNREALIZED_VALUE_DATA,
  });
